import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { QuantityUnit } from '@web/shared/module/measurement';
import { WarehouseGoodType } from '../../enums/warehouse-good-type';
import { AdminWarehouseGoodBrandResponse } from './admin-warehouse-good-brand.response';
import { AdminWarehouseGoodLocalizationResponse } from './admin-warehouse-good-localization.response';

@jsonObject
export class AdminWarehouseGoodDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly type!: WarehouseGoodType;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(String)
  public readonly quantityUnit!: QuantityUnit;

  @jsonMember(String)
  public readonly sku!: string;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(AdminWarehouseGoodBrandResponse)
  public readonly brand!: AdminWarehouseGoodBrandResponse;

  @jsonMember(AdminWarehouseGoodLocalizationResponse)
  public readonly localisation?: Nillable<AdminWarehouseGoodLocalizationResponse>;

  @jsonMember(Boolean)
  public readonly promotion!: boolean;

  @jsonMember(String)
  public readonly durabilityInformation!: string;

  @jsonMember(String)
  public readonly measure!: string;
}
